import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudRadioButtonModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { ModalSidebarModule } from 'shared/components/modal-sidebar/modal-sidebar.module';

import { ContactsTableBaselineFilterModule } from '../contacts-table-baseline-filter/contacts-table-baseline-filter.module';
import { ContactsTableFiltersSidebarComponent } from './contacts-table-filters-sidebar.component';

@NgModule({
	declarations: [ContactsTableFiltersSidebarComponent],
	imports: [
		CommonModule,
		TranslateModule,
		ModalSidebarModule,
		FreudTypographyModule,
		FreudButtonModule,
		ReactiveFormsModule,
		FormsModule,
		FreudRadioButtonModule,
		ContactsTableBaselineFilterModule,
	],
	exports: [ContactsTableFiltersSidebarComponent],
	providers: [],
})
export class ContactsTableFiltersSidebarModule {}
